export const environment = {
  basepath: 'procedures',
  production: true,
  baseUrl: 'https://gz.lot-online.ru/',
  apiUrl: 'https://gz.lot-online.ru/v1/',
  onlyLocalRequests: false,
  commissionUrl: 'https://gz.lot-online.ru/etp_back/commission/commission-list',
  logoutAfter: 3600,
  auth_url: 'https://gz.lot-online.ru/etp_front/login-ecp',
  home_url: 'https://gz.lot-online.ru/etp_front/',
  logout_url: 'https://gz.lot-online.ru/logout',
  without_signature_mode: false,
  remote_auth_mode: true,
  only_user_cert: false,
  timezoneUser: '+03:00',
  timezoneUserOffsetMsk: '+00:00',
  timezoneDefault: '+03:00',
  timezoneDefaultOffsetMsk: '+00:00',
  gost_check: true,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts